const OFFSET_TIMEZONE_PATTERN = /^(?:UTC|GMT)?\s*([+-])\s*(\d{1,2})(?::?([0-5]\d))?$/i;

export const resolveBrowserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch (error) {
    return 'UTC';
  }
};

export const normalizeTimezone = (value) => {
  const raw = String(value || '').trim();
  return raw || resolveBrowserTimezone();
};

const parseOffsetTimezoneToMinutes = (timezone) => {
  const match = String(timezone || '').trim().match(OFFSET_TIMEZONE_PATTERN);
  if (!match) return null;

  const sign = match[1] === '-' ? -1 : 1;
  const hours = Number(match[2]);
  const minutes = Number(match[3] || 0);
  if (!Number.isFinite(hours) || hours > 14 || !Number.isFinite(minutes)) return null;

  return sign * ((hours * 60) + minutes);
};

const getTimezoneOffsetMs = (date, timezone) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(date);

  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const asUtc = Date.UTC(
    Number(values.year),
    Number(values.month) - 1,
    Number(values.day),
    Number(values.hour),
    Number(values.minute),
    Number(values.second)
  );

  return asUtc - date.getTime();
};

export const zonedDateTimeToUnix = (dateTimeStr, timezoneValue) => {
  if (!dateTimeStr) return null;

  const [datePart, timePart] = String(dateTimeStr).split('T');
  if (!datePart || !timePart) return null;

  const [year, month, day] = datePart.split('-').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);
  if (![year, month, day, hour, minute].every(Number.isFinite)) return null;

  const timezone = normalizeTimezone(timezoneValue);
  const localAsUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
  const fixedOffsetMinutes = parseOffsetTimezoneToMinutes(timezone);
  if (fixedOffsetMinutes !== null) {
    return Math.floor((localAsUtc - fixedOffsetMinutes * 60 * 1000) / 1000);
  }

  try {
    let utcTime = localAsUtc;
    for (let index = 0; index < 3; index += 1) {
      utcTime = localAsUtc - getTimezoneOffsetMs(new Date(utcTime), timezone);
    }
    return Math.floor(utcTime / 1000);
  } catch (error) {
    return Math.floor(localAsUtc / 1000);
  }
};
